import { _isBlank } from '@/littledash';
import type { FC } from 'react';
import { Tooltip as ReactTooltip } from 'react-tooltip';

export const GLOBAL_TOOLTIP_ID = 'global-tooltip-id';

/**
 * react-tooltip 6 opens for any non-null content, so an anchor with `data-tooltip-content=""` shows an empty box.
 * Anchors across the app use a blank string to mean "no tooltip", as react-tooltip 5 did.
 */
const hasBlankContent = (anchor: Element | null): boolean => _isBlank(anchor?.getAttribute('data-tooltip-content'));

/**
 * The app-wide tooltip for every anchor with `data-tooltip-id={GLOBAL_TOOLTIP_ID}`. Anchors with blank content stay
 * closed.
 */
const GlobalTooltip: FC = () => (
  <ReactTooltip id={GLOBAL_TOOLTIP_ID} float={false} className="reacttooltip" disableTooltip={hasBlankContent} />
);

export default GlobalTooltip;
